<template>
  <div class="wrapper">
    <div class="imgContent">
      <!-- 单张图 -->
      <div v-if="list.length == 1" class="oneImgCon">
        <div
          v-for="(imgItem, index) in list"
          :key="index"
          @click="lookBigPicture(index)"
        >
          <img :src="imgItem.url" alt="" />
        </div>
      </div>
      <!-- 4张图 -->
      <div v-else-if="list.length == 4" class="moreImgCon">
        <div
          v-for="(imgItem, index) in list"
          :key="index"
          class="moreImgPer"
          @click="lookBigPicture(index)"
        >
          <img :src="imgItem.url" alt="" />
        </div>
      </div>
      <!-- 多张图 -->
      <div v-else class="moreImgCon">
        <div
          v-for="(imgItem, index) in list"
          :key="index"
          class="moreImgPer"
          @click="lookBigPicture(index)"
        >
          <img :src="imgItem.url" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pictureList"],
  data() {
    return {
      list: [], // 图片列表
      images: [],
      showPhoto: false, // 图片轮播显示
      indexPhoto: 0,
    };
  },
  mounted() {
    this.list = this.pictureList;
    this.transImg();
  },
  methods: {
    // 点击查看大图
    lookBigPicture(index) {
      var val = { imgList: this.images, position: index };
      // console.log(JSON.stringify(val));
      this.currency("toShowBigImg", JSON.stringify(val));
    },
    // 转换数据格式
    transImg() {
      for (let i in this.list) {
        this.images.push(this.list[i].url);
      }
    },
    // 图片变化
    onChange(index) {
      this.indexPhoto = index;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  .imgContent {
    width: 100%;
    margin-top: 7px;
    .oneImgCon {
      img {
        max-width: 100%;
        max-height: 150px;
      }
    }
    .moreImgCon {
      display: flex;
      flex-wrap: wrap;
      .moreImgPer {
        width: 32%;
        padding-bottom: 23.14%;
        position: relative;
        margin-right: 2%;
        margin-bottom: 2%;
        &:nth-child(3n) {
          margin-right: 0px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0px;
          left: 0px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>